export default function Footer(){
	const arrow = "<-/"
	return(
		<div id="arrow">
			<h2 className="link">{arrow} PROJECTS</h2>
		</div>
	)
}